import config from 'config';
import { format } from 'date-fns';
import { NotificationPayloadOutput } from 'gql/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type PropTypes = {
  payload: NotificationPayloadOutput;
};

const DonorUnenrolled: FC<PropTypes> = ({ payload }) => {
  const { t } = useTranslation('notification.NotificationCard.DonorUnenrolled');
  const appointment = payload?.appointment;
  if (!appointment) {
    return null;
  }
  const owner = appointment.donor?.user;
  const content = t('donorJustUnenrolled', {
    appointmentTitle: appointment.title,
    ownerName: `${owner?.lastName} ${owner?.firstName}`,
    donorName: `${appointment.donor?.name} ${appointment.donor?.user?.lastName}`,
    start: format(
      new Date(appointment.start),
      config.DATE_FORMATS.LOCALIZED_TIME
    ),
    end: format(new Date(appointment.end), config.DATE_FORMATS.LOCALIZED_TIME),
    context: appointment.group ? 'withDonor' : undefined,
  });
  return <>{content}</>;
};

export default DonorUnenrolled;
